export default __webpack_public_path__ + "static/media/arrow-drop.5b29ab88.svg";